import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IRequestCallback, RequestService } from '@df/api/request/request.service';
import { Events } from '@df/core/service/event';
import { Status } from '@df/core/status';
import { NewsletterChangeEvent } from '@df/session/newsletter/newsletter-change.event';
import { NewsletterUpdateEvent } from '@df/session/newsletter/newsletter-update.event';
import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';
import compact from 'lodash-es/compact';
import flatten from 'lodash-es/flatten';
import { Subject } from 'rxjs';

/**
 * Newsletter service. Allows to subscribe by email, unsubscribe by email, unsubscribe by
 *
 * @export
 * @class SessionStorage
 * @extends {LocalStorage}
 */
@Injectable({
    providedIn: 'root'
})
export class NewsletterService {
    readonly newsletterStatus = new Subject<NewsletterChangeEvent | NewsletterUpdateEvent>();

    constructor(private requestService: RequestService, private events: Events) {}

    /**
     * Subscribes by email or customer id
     */
    subscribe(
        form: NgForm | undefined,
        status: Status | undefined,
        data: Newsletter.ISubscribeRequest,
        onSuccess?: IRequestCallback,
        onError?: IRequestCallback
    ): Promise<Newsletter.IResponse> | void {
        const event: Newsletter.ISubscriptionEvent = {
            callback: data => this.requestService.send(status, () => this.requestService.nexus.newsletter.subscribe(data))
        };
        this.events.broadcast(Newsletter.subscriptionRequest, event);
        return this.requestService.submitForm<Newsletter.IResponse>(
            form,
            status,
            () => event.callback(data),
            compact(flatten([onSuccess, () => this.newsletterStatus.next(new NewsletterChangeEvent(data.email, true, data))])),
            onError
        );
    }

    /**
     * Unsubscribes by email or customer id
     *
     * The methods does not seem like it was ever working or was used
     */
    // unsubscribe(
    //     status: Status | undefined,
    //     data: Newsletter.IUnsubscribeRequest,
    //     onSuccess?: IRequestCallback,
    //     onError?: IRequestCallback
    // ): Promise<Newsletter.IResponse> | void {
    //     return this.requestService.send<Newsletter.IResponse>(
    //         status,
    //         () => this.nexusApiService.newsletter.unsubscribe(data){ path: 'newsletter/unsubscribe', data },
    //         compact(
    //             flatten([
    //                 onSuccess,
    //                 () =>
    //                     this.newsletterStatus.next(
    //                         new NewsletterChangeEvent((<Newsletter.IEmailUnsubscribeRequest>data).email, false, data)
    //                     )
    //             ])
    //         ),
    //         onError
    //     );
    // }

    /**
     * This provides the functionality extending regular newsletter subscription. It allows to control additional
     * subscriptions that are assigned to regular Subscriber. For example, catalogoue subscriprion or post subscription.
     * Any additional subscription needs to be additionally implemented in backend.
     */
    update(
        status: Status | undefined,
        data: Newsletter.IUpdateRequest,
        onSuccess?: IRequestCallback,
        onError?: IRequestCallback
    ): Promise<Newsletter.IResponse> | void {
        return this.requestService.send<Newsletter.IResponse>(
            status,
            { path: 'newsletter/update', data },
            compact(flatten([onSuccess, () => this.newsletterStatus.next(new NewsletterUpdateEvent(data))])),
            onError
        );
    }

    /**
     * Unsubscribes while logged into your account
     */
    unsubscribeByAccount(
        status: Status | undefined,
        onSuccess?: IRequestCallback,
        onError?: IRequestCallback
    ): Promise<Newsletter.IResponse> | void {
        return this.requestService.send<Newsletter.IResponse>(
            status,
            { path: 'newsletter/unsubscribeByAccount', data: {} },
            onSuccess,
            onError
        );
    }
}
